import { ValidationErrorResponseSchema } from '@mntn/api-contracts/_shared/error-responses'
import { ErrorResponseSchema } from '@mntn/result'
import { initContract } from '@ts-rest/core'
import {
  GetProgramGenresQuerySchema,
  GetProgramGenresRequestSchema,
  GetProgramGenresResponseSchema,
} from './schemas.ts'

const c = initContract()

export const programGenresContract = c.router(
  {
    list: c.query({
      method: 'GET',
      path: '/seller/v1/program-genres',
      description: 'Get program genres',
      query: GetProgramGenresQuerySchema,
      request: GetProgramGenresRequestSchema,
      responses: GetProgramGenresResponseSchema,
    }),
  },
  {
    strictStatusCodes: true,
    commonResponses: {
      400: ValidationErrorResponseSchema,
      403: ErrorResponseSchema,
    },
    metadata: { tags: ['Program Genres'] },
  },
)

export type ProgramGenresContract = typeof programGenresContract
